import { Info } from 'lucide-react'
import { useTranslations } from '../providers/ContactServiceProvider'

// The "Agregar contacto" action lives ONLY in ContactGrid's header now (top-right, same spot
// and same button regardless of whether there are contacts yet) — this used to render its own
// second copy here, bottom-centered, so an empty record showed two differently-styled buttons
// for the same action.
export function ContactGridEmptyState() {
  const t = useTranslations()

  return (
    <div className="flex flex-col items-center gap-4">
      <div className="flex w-full items-center gap-3 rounded-lg border border-blue-200 bg-blue-50 px-4 py-3 dark:border-blue-800/50 dark:bg-blue-950/30">
        <Info className="h-5 w-5 shrink-0 text-blue-600 dark:text-blue-400" />
        <p className="text-sm text-blue-800 dark:text-blue-200">
          {t.grid.emptyBanner}
        </p>
      </div>
    </div>
  )
}
